import { render, staticRenderFns } from "./AboutModal.vue?vue&type=template&id=afee7762&scoped=true"
import script from "./AboutModal.vue?vue&type=script&lang=js"
export * from "./AboutModal.vue?vue&type=script&lang=js"
import style0 from "./AboutModal.vue?vue&type=style&index=0&id=afee7762&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afee7762",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('afee7762')) {
      api.createRecord('afee7762', component.options)
    } else {
      api.reload('afee7762', component.options)
    }
    module.hot.accept("./AboutModal.vue?vue&type=template&id=afee7762&scoped=true", function () {
      api.rerender('afee7762', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BulmaModal/AboutModal.vue"
export default component.exports